import {type LocationIdType} from '../../store/state/locations/state'
import {type VesselFiltersState} from '../../store/state/my-vessels-filters/types/my-vessel-filter-state'
import {type VesselTag} from '../../api/vessels/vessel-tags'
import {type MyVesselsFilter} from '../../values/user-preferences/my-vessels-filter'

export enum PageType {
    MY_VESSELS = 'my-vessels-filter',
    INCIDENTS = 'incidents_settings',
    REPORTS = 'reports-filter',
    NETWORK_ASSETS = 'unknown_assets_settings_v2',
    USB_DEVICES = 'usb_devices',
    SOFTWARE_INVENTORY = 'software_inventory',
    NMEA_INVENTORY = 'nmea_inventory',
    METRICS = 'metrics_beta',
    VESSELS_BETA = 'vessels_beta',
    VESSEL_MANAGEMENT = 'vessel_management',
    INCIDENTS_REPORT = 'incidents_report',
    OT_INVENTORY = 'ot_inventory',
}

export function findRecommendationFromEntryTag(
    existingTags: VesselTag[] | undefined,
    searchTag: string,
): VesselTag[] {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!existingTags || !searchTag || !searchTag?.trim()) {
        return []
    }
    return (
        existingTags
            .filter((element) =>
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                element.name?.trim().toLowerCase().includes(searchTag?.trim().toLowerCase()),
            ) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            .sort((a, b) => a.name?.localeCompare(b.name))
            .slice(0, 5)
    )
}

function populateLocationsForFilterCriteria(
    locations: Set<LocationIdType> | undefined,
): LocationIdType[] | undefined {
    try {
        if (!locations) {
            return undefined
        }
        return Array.from(locations)
    } catch (err) {
        console.error({err, locations})
        return undefined
    }
}

export function buildMyVesselsFilterPrefs(state: VesselFiltersState): MyVesselsFilter {
    return {
        zoomLevel: state.zoomLevel,
        vesselSort: state.vesselSort,
        assetSort: state.assetSort,
        HIGH: state.HIGH,
        MEDIUM: state.MEDIUM,
        LOW: state.LOW,
        locations: populateLocationsForFilterCriteria(state.locations),
        searchVesselTagTerm: state.searchVesselTagTerm,
        searchVesselNameTerm: state.searchVesselNameTerm,
    }
}
